module.exports = __webpack_public_path__ + "img/06.caaa0fae.png";